__webpack_require__.p = "/manager/static/dist/";